module.exports = __webpack_public_path__ + "img/SMT_53_Ms_May_Low.6d588c1a.jpg";